import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-wage-audit-dialog',
  templateUrl: './wage-audit-dialog.component.html',
  styleUrls: ['./wage-audit-dialog.component.scss']
})
export class WageAuditDialogComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
  'auditId',
  'wageId',
  'employeeId',
  'employeeName',
  'salaryAmount',
  'expId',
  'empLoan',
  'penalty',
  'bonus',
  'remarks',
  'modifiedAt'
];


  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WageAuditDialogComponent>,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.apiService.getWageAuditByWageId(this.data.wageId).subscribe((response: any) => {
      this.dataSource.data = response || [];
      console.log("Audit Response:", response);

      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
      });
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
